import { useMemo } from 'react';
import { useAuthUser } from '../../misc/lib/user';
import routes from '../../misc/routes';
import './Footer.scss';

const Footer = () => {
  const user = useAuthUser()[ 0 ];
  const pageUrl = useMemo(() => {
    if (window.location.hostname === 'localhost') return 'bathory-dse.hu';
    else return window.location.hostname;
  }, []);

  return (
    <div className="app-footer">
      <h1>{ pageUrl }</h1>
      <p>A Báthory István Diák Sport Egyesület hivatalos weboldala.</p>
      <p><a href={ routes.about.path }>Az egyesületről hosszabban...</a></p>
      <div className="footer-more-pages">
        <h3>Egyéb oldalak:</h3>
        <ul>
          <li><a href="/adatvedelem.pdf">Adatvédelmi tájékoztató</a></li>
          <li><a href="https://www.facebook.com/bathorygimi">Facebook oldalunk</a></li>
          <li><a href={ routes.login.path }>
            { !user ? routes.login.title : 'Rendszergazdai felület' }
          </a></li>
        </ul>
      </div>
      <p className="footer-copyright">
        Copyright © 2021 <a
          href="https://www.github.com/klevcsoo"
        >Keve Lajsz</a>. All Rights Reserved
      </p>
    </div>
  );
};

export default Footer;
